import {
  FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION_API,
  FETCH_CLIENT_CABINET_CLIENT_COMMISSION_API,
  FETCH_CLIENT_CABINET_IB_REFERRALS_API,
  FETCH_EXCHANGE_RATE_API,
  FETCH_SOCIAL_TRADING_FEES_API,
  INITIATE_STK_PUSH_API,
  MONITORING_CLIENTS_API,
  MONITORING_META_CLIENTS_API,
  SOCIAL_SIGN_IN_API,
  SUBMIT_DOCUMENTS_API,
  TRADE_LITE_ROUTE,
  TRADE_MT5_ROUTE,
  TRADE_PRO_ROUTE,
  TRADE_ROUTE,
  WITHDRAW_API,
} from "_constants";
import { AppRedirect } from "_lib";
import { Navigate } from "react-router-dom";

export const generateRoutes = (structure) => {
  const {
    authorizedStructure,
    unAuthorizedStructure,
    anonymousStructure,
    isAuthenticated,
    alwaysStructure,
  } = structure || {};

  const dynamicRoutes = [];

  if (authorizedStructure) {
    dynamicRoutes.push(
      ...routesGenerator(isAuthenticated, authorizedStructure, "authorized")
    );
  }
  if (anonymousStructure) {
    dynamicRoutes.push(
      ...routesGenerator(isAuthenticated, anonymousStructure, "anonymous")
    );
  }
  if (unAuthorizedStructure) {
    dynamicRoutes.push(
      ...routesGenerator(isAuthenticated, unAuthorizedStructure, "unauthorized")
    );
  }
  if (alwaysStructure) {
    dynamicRoutes.push(
      ...routesGenerator(isAuthenticated, alwaysStructure, "always")
    );
  }

  // alternative to cater for rogue routes for now
  if (dynamicRoutes.length > 0) {
    dynamicRoutes.push({
      path: "*",
      element: (
        <Navigate
          to={
            isAuthenticated
              ? unAuthorizedStructure.fallbackPath
              : authorizedStructure.fallbackPath
          }
          replace
        />
      ),
    });
  }

  return dynamicRoutes;
};

const routesGenerator = (
  isAuthenticated = false,
  routeSet = {},
  type = "anonymous"
) => {
  const generatedRoutes = [];
  let { fallbackPath = "", redirectPath = "" } = routeSet || {};

  const isAnonymous = type === "anonymous";
  const isAuthorized = type === "authorized";
  const isUnauthorized = type === "unauthorized";
  const isAlways = type === "always";

  if (routeSet?.routes) {
    const routes = routeSet.routes;
    if (Array.isArray(routes) && routes.length > 0) {
      routes.forEach((route) => {
        if (isAnonymous) {
          generatedRoutes.push({ ...route });
          generatedRoutes.push(route);
        }
        if (isAuthorized) {
          generatedRoutes.push(
            isAuthenticated
              ? { ...route }
              : {
                  path: route.path,
                  element: (
                    <AppRedirect
                      to={fallbackPath}
                      isTestingOnly={route?.isTestingOnly}
                    />
                  ),
                }
          );
        }
        if (isUnauthorized) {
          generatedRoutes.push(
            !isAuthenticated
              ? { ...route }
              : {
                  path: route.path,
                  element: (
                    <Navigate to={redirectPath || fallbackPath} replace />
                  ),
                }
          );
        }
        if (isAlways) {
          generatedRoutes.push({ ...route });
        }
      });
    }
  }

  return generatedRoutes;
};

export const isRouteExcludedFromSuccessMessage = (url) => {
  return !![
    FETCH_EXCHANGE_RATE_API,
    SOCIAL_SIGN_IN_API,
    WITHDRAW_API,
    INITIATE_STK_PUSH_API,
    SUBMIT_DOCUMENTS_API,
    FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION_API,
    FETCH_CLIENT_CABINET_CLIENT_COMMISSION_API,
    FETCH_CLIENT_CABINET_IB_REFERRALS_API,
    MONITORING_CLIENTS_API,
    MONITORING_META_CLIENTS_API,
    FETCH_SOCIAL_TRADING_FEES_API,
  ].find((route) => route === url);
};

export const isRouteExcludedFromErrorMessage = (url) => {
  return !![
    SOCIAL_SIGN_IN_API,
    MONITORING_META_CLIENTS_API,
    MONITORING_CLIENTS_API,
  ].find((route) => route === url);
};

export const getIsTradeRoute = (route) => {
  return !![
    TRADE_ROUTE,
    TRADE_LITE_ROUTE,
    TRADE_MT5_ROUTE,
    TRADE_PRO_ROUTE,
  ].includes(route);
};
